// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WypA","buttons":"styles_buttons__3HfXc"};